export const SWR_SOURCE = 'swr'
export const SWR_ACTION_SOURCE = 'standard_work_review'
export const SWR_LIST = 'swr-list'
export const SWR_DETAILS = 'swr-detail'
export const SWR_BASE_URL = 'standard-reviews/'
export const SWR_SETTINGS_TOLERANCE = 'settings-standard-work-review'
export const EVALUATION_DETAILS = 'swr-evaluation-detail'
export const KEYPOINTS_AT_RISK_URL = 'stats/standard-reviews/datasets/keypoints-at-risk/'
export const TYPE_PPE = 0
export const TYPE_SEQUENCE = 1
export const TYPE_ANNOTATION = 2
export const TYPE_TIME_CYCLE = 3
export const AUDITS_EVOLUTION_CHARTS_KEY = 'audits_by_temporality'
export const CREATED_CLOSED_EVOLUTION_CHART_KEY = 'created_and_verified_actions_by_temporality'
export const AUDITS_COUNT_BY_TEMPORALITY_VISIBILITY_KEY = 'audits_count_by_temporality'
export const AUDITS_AVG_SCORE_BY_TEMPORALITY_VISIBILITY_KEY = 'audits_avg_score_by_temporality'
export const KEYPOINT_INDICATOR_CONFIG_KEY = 'keypoint_indicator'
export const IMPROVEMENTS_ACTIONS_INDICATOR_CONFIG_KEY = 'improvements_actions_indicator'
export const ACTION_STATUS_INDICATOR_CONFIG_KEY = 'action_status'
export const EXPIRED_ON_DATE_INDICATOR_CONFIG_KEY = 'expired_on_date_actions'
